"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "piedimulera": {
    "d97571d9": [{
      "hkey": "73432545",
      "slug": "piedimulera",
      "name": "Piedimulera",
      "primary": true,
      "skipSearch": false
    }],
    "casa-negro": [{
      "hkey": "73432545",
      "slug": "piedimulera",
      "name": "Piedimulera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "20d471a3": [{
      "hkey": "73432545",
      "slug": "piedimulera",
      "name": "Piedimulera",
      "primary": true,
      "skipSearch": false
    }],
    "case-girardi": [{
      "hkey": "73432545",
      "slug": "piedimulera",
      "name": "Piedimulera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2212ec33": [{
      "hkey": "73432545",
      "slug": "piedimulera",
      "name": "Piedimulera",
      "primary": true,
      "skipSearch": false
    }],
    "chiesa": [{
      "hkey": "73432545",
      "slug": "piedimulera",
      "name": "Piedimulera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0907450d": [{
      "hkey": "73432545",
      "slug": "piedimulera",
      "name": "Piedimulera",
      "primary": true,
      "skipSearch": false
    }],
    "coletto": [{
      "hkey": "73432545",
      "slug": "piedimulera",
      "name": "Piedimulera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6623cd41": [{
      "hkey": "73432545",
      "slug": "piedimulera",
      "name": "Piedimulera",
      "primary": true,
      "skipSearch": false
    }],
    "croppala": [{
      "hkey": "73432545",
      "slug": "piedimulera",
      "name": "Piedimulera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dc6eda63": [{
      "hkey": "73432545",
      "slug": "piedimulera",
      "name": "Piedimulera",
      "primary": true,
      "skipSearch": false
    }],
    "crosa": [{
      "hkey": "73432545",
      "slug": "piedimulera",
      "name": "Piedimulera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "68a55fb3": [{
      "hkey": "9ec80bea",
      "slug": "gozzi",
      "name": "Gozzi",
      "primary": true,
      "skipSearch": false
    }],
    "gozzi-sopra": [{
      "hkey": "9ec80bea",
      "slug": "gozzi",
      "name": "Gozzi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5378334d": [{
      "hkey": "9ec80bea",
      "slug": "gozzi",
      "name": "Gozzi",
      "primary": true,
      "skipSearch": false
    }],
    "gozzi-sotto": [{
      "hkey": "9ec80bea",
      "slug": "gozzi",
      "name": "Gozzi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "piedimulera"
    }],
    "571d9c45": [{
      "hkey": "73432545",
      "slug": "piedimulera",
      "name": "Piedimulera",
      "primary": true,
      "skipSearch": false
    }],
    "mezzamulera": [{
      "hkey": "73432545",
      "slug": "piedimulera",
      "name": "Piedimulera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4fe532b0": [{
      "hkey": "73432545",
      "slug": "piedimulera",
      "name": "Piedimulera",
      "primary": true,
      "skipSearch": false
    }],
    "morlongo": [{
      "hkey": "73432545",
      "slug": "piedimulera",
      "name": "Piedimulera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "465544bd": [{
      "hkey": "73432545",
      "slug": "piedimulera",
      "name": "Piedimulera",
      "primary": true,
      "skipSearch": false
    }],
    "piana": [{
      "hkey": "73432545",
      "slug": "piedimulera",
      "name": "Piedimulera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;